<div class="footer-container">
  <div class="container">
    <div class="container-columns">

      <div class="container-column1">
        <div style="margin-bottom: 25px;">
          <span class="texto-principal">
            Llevá tu comercio al <br>siguiente nivel.
          </span><br>
          <span class="subTexto">
            Adherí tu negocio y comenzá a <br>operar con tarjetas.
          </span>
        </div>
        <div class="container-button-text">
          <button mat-button class="defensaAlConsumidor"
            (click)="defensaConsumidor()">
            Defensa de las y los Consumidores. <br>Para reclamos
            ingrese aquí
          </button>
          <p class="parrafo">
            El presente canal solo debe ser utilizado si no ha sido
            satisfecho su reclamo pertinente por
            el
            servicio o producto habilitado por el canal al efecto.
          </p>
        </div>

      </div>
      <div>
        <div>
          <ul style="list-style: none;">
            <div>
              <li>
                <a href="https://www.fiserv.com.ar/proteccion-datos/"
                  target="_blank">Protección de datos</a>
              </li>
              <li>
                <a href="{{URL}}privacy-policy"
                  target="_blank">Aviso de privacidad</a>
              </li>
              <li>
                <a href="https://www.fiserv.com.ar/global-selector/"
                  target="_blank">Argentina/Change</a>
              </li>
              <li>
                <a href="{{URL}}Preguntas-Frecuentes"
                  target="_blank">Preguntas Frecuentes</a>
              </li>
            </div>
            <div>
              <li>
                <div class="dataFiscal">
                  <a class="imageFiscal"
                    href="https://www.afip.gob.ar/landing/default.asp"
                    target="_blank"><img class="image"
                      src="assets/images/logos/data-fiscal.jpg"
                      alt="" /></a>
                </div>
              </li>
            </div>
          </ul>
        </div>
      </div>
    </div>
  </div>